import ProductDetailsCard from './ProductDetailsCard';

export default ProductDetailsCard;
